module.exports = __webpack_public_path__ + "img/11.49ab49b6.jpg";